<div class="container">
    <br />
    <div class="row g-0">
        <div class="col-lg-2">
            <img src="assets/images/logo.png" class="img-thumbnail" alt="LogoCamaraDiptuados" />
        </div>
        <div class="row col-lg-10">
            <p class="h2" style="text-align: right">
                <b>Cartas de intención</b> remitidas a la Cámara de Diputados
                para participar en el Proceso Electoral Federal 2023-2024 en elección consecutiva.
            </p>
        </div>
        <div class="col-lg-12 row">


            <!-- <p class="alert alert-success text-center">
                El presente listado, corresponde a las diputadas y diputados que cumplieron con la entrega de 
                los avisos de intención, <br>
                remitidos exclusivamente a las autoridades de la Cámara de Diputados.
            
            </p> -->
            <p class="text-end">
                <b>Nota</b>
                La entrega de la carta de intención a las autoridades de la Cámara no exime de la entrega de la
                documentación correspondiente al INE y los partidos políticos.
            </p>
            <!-- 
                Manuel solicitó quitar el conteo
                <p class="text-end text-muted">
                Total de registros <b>{{contendientes.length}}</b>
            </p>
             -->
        </div>
    </div>
    <form [formGroup]="formulario">
        <div class="row mb-3 justify-content-end">
            <div class="col-12 col-lg-4 mb-lg-0 mb-2">
                <input class="form-control me-2" placeholder="Nombre de la diputada o diputado" type="text" formControlName="nombre"
                    maxlength="50" />
                <span *ngIf="campoNoEsValido('nombre')" class="text-danger">{{
                    procendenciaMSG }}</span>
            </div>
            <div class="col-6 col-md-2 col-lg-1">
                <button type="submit" at-raised-button color="success" class="col-12 btn btn-success"
                    (click)="buscarContendientes()">
                    Buscar
                </button>
            </div>
            <!-- <div class="col-6 col-md-2 col-lg-2">
                <button type="submit" at-raised-button color="success" class="col-12 btn btn-success"
                    (click)="limpiarFormulario()">
                    Limpiar
                </button>
            </div> -->
        </div>
    </form>
    <div class="row">
        <div class="table-responsive">
            <table class="table ">
                <thead class="table green">
                    <tr>
                        <th class="enc_centrado" scope="col">N°</th>
                        <th class="enc_centrado" scope="col">Diputada / Diputado</th>
                        <th class="enc_centrado" scope="col">Grupo Parlamentario</th>
                        <th class="enc_centrado" scope="col">Entidad federativa</th>
                        <th class="enc_centrado" scope="col">Distrito / Circunscripción</th>
                        <th class="enc_centrado" scope="col">Tipo de elección</th>
                        <th class="enc_centrado" scope="col">Fecha de recepción</th>
                        <th class="enc_centrado" scope="col">En funciones</th>
                        <!-- <th class="enc_centrado" scope="col">Reelecciones Previas</th> -->
                        <!-- <th class="enc_centrado" scope="col">Folio</th> -->
                        <th class="enc_centrado" scope="col">Carta</th>
                    </tr>
                </thead>
                <tbody *ngFor="let c of contendientes">
                    <tr>
                        <td>{{ c.Numero }}</td>
                        <td>{{ c.NombreDiputado }}</td>
                        <td>{{ c.GrupoParlamentario }}</td>
                        <td>{{ c.EntidadFederativa }}</td>
                        <td>{{ c.DistritoCircuns }}</td>
                        <td>{{ c.TipoEleccion }}</td>
                        <td>{{ c.FechaRecepcion | date: "dd 'de' MMMM 'del' yyyy":'UTC' }}</td>
                        <td>{{ c.EnFunciones }}</td>
                        <!-- <td><span *ngIf="c.ReeleccionPrevia == 1">{{ c.ReeleccionesLegilatura }}</span> </td> -->
                        <!-- <td>{{ c.Folio }}</td> -->
                        <td>
                            <button type="button" class="btn btn-success" *ngIf="c.Enlace !== 0; else noFiles"
                                (click)="downloadBase64File(c)">
                                Descargar
                            </button>
                            <!-- <button type="button" class="btn btn-primary" *ngIf="c.Enlace !== 0; else noFiles"
                                (click)="VerCarta(c.Oid)">
                                Ver
                            </button> -->
                            <ng-template #noFiles>
                        <td></td>
                        </ng-template>
                        </td>
                    </tr>
                    <tr *ngIf="c.Notas !== null && c.Notas">
                        <td colspan="12">
                            <table class="table">
                                <thead class="table-light">
                                    <tr>
                                        <td><b> Notas:</b> {{ c.Notas }}</td>
                                    </tr>
                                </thead>
                                <!-- <tbody>
                                <tr>
                                    <td></td>
                                </tr>
                            </tbody> -->
                            </table>
                        </td>
                    </tr>
                </tbody>
                <ng-template #loadingFiles>Cargando...</ng-template>
            </table>
        </div>
    </div>

    <div class="row col-12 pt-2">
        <hr>

        La Presidencia de Mesa Directiva y la Secretaría General de la Cámara de Diputados, se dan por notificadas
        de la
        recepción de las Cartas de Intención publicadas en el presente portal; de conformidad con el Artículo 6 de
        los
        Lineamientos sobre Elección Consecutiva para Senadurías y Diputaciones Federales por ambos principios, para
        el
        Proceso Electoral Federal 2023-2024.
        <br>
        <br>

        Nota: El presente portal refleja las cartas de intención recibidas de diputadas y diputados
        titulares y suplentes.

    </div>


</div>